import {useCallback, useEffect, useRef} from 'react';

import {useGoogleOAuth} from './GoogleOAuthContext';

/**
 * Hook that returns a function that once called open the Google login consent page and if case
 * of a success return the response with the authorization code and the flagged scopes.
 */
const useGoogleAuthorizationCode = (props) => {
    const { scope, onSuccess, onError, ...callbackProps} = props;
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const clientRef = useRef();

    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;

    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;

    useEffect(() => {
        if (scriptLoadedSuccessfully){
            const clientMethod = 'initCodeClient'; // configuration to get an authorization code
            clientRef.current = window.google?.accounts.oauth2[clientMethod]({
                client_id: clientId,
                scope: `${scope}`,
                callback: (response) => {
                    if (response.error) return onErrorRef.current?.(response);
                    onSuccessRef.current?.(response);
                },
                ...callbackProps,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, scriptLoadedSuccessfully, scope]);

    return useCallback(
        () => clientRef.current.requestCode(),
        [],
    );
}

export default useGoogleAuthorizationCode;

